import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import LabResultList from 'containers/testResult/LabResultList';
import { Bubble } from 'ctia-ui';
import {
  clearRequests,
  fetchApprovedRequestsForTesting
} from 'actions/requests';
import { startPreloader, finishPreloader } from 'actions/preloader';

class TestResultsList extends Component {
  componentDidMount() {
    const {
      startPreloader,
      finishPreloader,
      clearRequests,
      fetchApprovedRequestsForTesting
    } = this.props;

    startPreloader();
    clearRequests();
    fetchApprovedRequestsForTesting().then(finishPreloader);
  }

  componentWillUnmount() {
    this.props.clearRequests();
  }

  render() {
    const { requests } = this.props;

    if (_.isNull(requests)) {
      return null;
    }

    const renderResults = () => {
      if (_.isEmpty(requests.list))
        return (
          <Bubble type="warning">
            No requests waiting for entering results yet. Check{' '}
            <Link to="/lab/requests">Request for Testing</Link> and approve them
            before.
          </Bubble>
        );
      return <LabResultList list={requests.list} />;
    };

    return (
      <div>
        <h1 style={{ paddingBottom: 15 }}>Test Results</h1>
        {renderResults()}
      </div>
    );
  }
}

function mapStateToProps({ requests }) {
  return { requests };
}

export default connect(
  mapStateToProps,
  {
    fetchApprovedRequestsForTesting,
    clearRequests,
    startPreloader,
    finishPreloader
  }
)(TestResultsList);



// WEBPACK FOOTER //
// ./src/containers/TestResultsList.js